import React from 'react';

import { HeaderWrapper, HeaderImage } from './styles.Header';
import { useGlobal } from '../../../logic/main';
import { mainConfig } from '../../../config/config.provider';

import header1600 from '../../../assets/images/header/header-1600w.jpg';
import header1020 from '../../../assets/images/header/header-1020w.jpg';
import header768 from '../../../assets/images/header/header-768w.jpg';
import header480 from '../../../assets/images/header/header-480w.jpg';

export const Header: React.FC = () => {
    const [navbarHeight] = useGlobal(state => state.navbarHeight);

    return (
        <HeaderWrapper>
            <HeaderImage
                title={mainConfig.headerCredits}
                alt={mainConfig.headerInfo}
                src={header1600}
                srcSet={`${header480} 480w, ${header768} 768w, ${header1020} 1020w, ${header1600} 1600w`}
                marginTop={navbarHeight}
            />
        </HeaderWrapper>
    );
};
